import Vue from "vue";
import Vuex from "vuex";
import api from "../api/api";
import getters from "./getters";
Vue.use(Vuex);
const modulesFiles = require.context("./modules", true, /\.js$/);
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

export default new Vuex.Store({
  modules,
  state: {
    user: {
      OpenId: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user")).id
        : "",
      Token: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user")).token
        : ""
    },
    loginData: JSON.parse(localStorage.getItem("user")) || {},
    isLogin: JSON.parse(localStorage.getItem("isLogin")) || false,
    percent: 0,
    fileIdData: {
      uid: null,
      fileId: null
    },
    uploadData: {
      index: null,
      percent: 0
    },
    resources: JSON.parse(localStorage.getItem("user"))
      ? JSON.parse(localStorage.getItem("user")).resources
      : [],
    authList: JSON.parse(localStorage.getItem("authList")) || []
  },
  actions: {
    login({ commit }, flag) {
      commit("index.vue", flag);
    },
    signOut(state) {
      state.isLogin = false;
      state.loginData = {};
      localStorage.removeItem("isLogin");
      localStorage.removeItem("user");
    },
    //获取权限按钮
    getAuthList({ commit }) {
      api.user.getButtonRoleResourceList().then(res => {
        localStorage.setItem("authList", JSON.stringify(res.data));
        commit("SET_AUTH_LIST", res.data);
      });
    },
    getCurrentUser({ commit, state }) {
      api.user
        .getUser({
          id: state.user.OpenId
        })
        .then(res => {
          commit("GET_CURRENT_USER", res.data);
        });
    }
  },
  getters: {
    ...getters,
    isLogin: state => state.isLogin,
    loginData: state => state.loginData,
    authList: state => state.authList
  },
  mutations: {
    login(state, flag) {
      state.isLogin = flag;
    },
    percent(state, num) {
      state.percent = num;
    },
    getUploadData(state, data) {
      state.uploadData = data;
    },
    getFileIdData(state, data) {
      state.fileIdData = data;
    },
    signIn(state, res) {
      state.isLogin = true;
      state.loginData = res;
      state.resources = res.resources;
      localStorage.setItem("isLogin", true);
      localStorage.setItem("user", JSON.stringify(res));
    },

    signOut(state) {
      state.isLogin = false;
      state.loginData = {};
      localStorage.removeItem("isLogin");
      localStorage.removeItem("lastRouter");
      localStorage.removeItem("user");
      localStorage.removeItem("currTabArr");
    },
    //权限按钮列表赋值
    SET_AUTH_LIST(state, view) {
      state.authList = view;
    },
    GET_CURRENT_USER(state, view) {
      state.loginData.resources = view.resources;
      state.loginData.roles = view.roles;
      state.resources = view.resources;
      localStorage.setItem("user", JSON.stringify(state.loginData));
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js